import { default as HomePage } from './HomePage';

export default HomePage;
